import React, { useState } from 'react'
import Close from '../../assets/close.svg'
import useCart from '../../cart/useCart'
import linkResolver from '../../utils/linkResolver'
import prismic from '../../utils/prismic'
import Image from '../blocks/image'
import ProductModal from './modal'

export default ({
  uid,
  product,
  onRemove,
  amount = null,
  className = '',
  ...props
}) => {
  if (!product) return null

  const [isModalOpen, setIsModalOpen] = useState(false)
  const { addToCart } = useCart()

  return (
    <li className={'py-2 border-t-2 border-gray-100 ' + className} {...props}>
      <div className="my-2 flex justify-between items-center">
        <a
          className="flex-1 flex items-center"
          href={linkResolver(product)}
          onClick={(event) => {
            if ('product' === product.type) {
              event.preventDefault()
              setIsModalOpen(true)
            }
          }}
        >
          <Image
            className="w-16 h-12 mr-4"
            alt={product.data ? product.data.title : product.title}
            image={
              product.variation?.imageSharp ||
              product.variation?.image ||
              product.imageSharp ||
              product.image ||
              product.data.image
            }
          />
          <div>
            <h2>{prismic(product.title || product.data.title)}</h2>
            {product.variation && (
              <p className="opacity-75">
                {product.variation.material_of_grip.text}
              </p>
            )}
          </div>
        </a>

        {amount && (
          <div className="flex items-center">
            <button
              className="p-2 text-gray-400"
              onClick={() => addToCart(product, -1)}
            >
              -
            </button>
            <span className="w-8 text-xl text-center font-bold">{amount}</span>
            <button
              className="p-2 text-gray-400"
              onClick={() => addToCart(product)}
            >
              +
            </button>
          </div>
        )}

        <div className="flex-shrink-0 pr-2 w-16 text-right">
          <button
            style={{
              transition: 'border-color .2s, color .2s',
            }}
            className="p-px border-2 border-gray-400 text-gray-400 rounded-full hover:text-red-500 hover:border-red-500"
            onClick={() => onRemove(uid)}
          >
            <Close
              style={{
                strokeWidth: 8,
              }}
              className="w-3 h-3"
            />
          </button>
        </div>
      </div>

      {isModalOpen && (
        <ProductModal product={product} onClose={() => setIsModalOpen(false)} />
      )}
    </li>
  )
}
